import { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, Copy } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ url: "", alt: "" });

  const load = useCallback(() => { api.get("/api/admin/media").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  async function create() {
    if (!form.url) { toast.error("URL required"); return; }
    await api.post("/api/admin/media", { url: form.url, alt: form.alt, kind: "image" });
    setForm({ url: "", alt: "" }); load(); toast.success("Added");
  }
  async function del(id) { await api.delete(`/api/admin/media/${id}`); load(); }

  return (
    <div className="mx-auto max-w-5xl">
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">Media library</h1>
      <p className="mt-1 text-sm text-slate-500">Register image URLs (CDN-ready). Object storage uploads can be added later without schema changes.</p>

      <div className="mt-6 flex flex-wrap items-end gap-3 rounded-2xl border border-slate-200 bg-white p-6">
        <div className="flex-1 min-w-[240px]"><Label>Image URL</Label><Input value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} placeholder="https://…" className="mt-1.5" data-testid="media-url" /></div>
        <div className="flex-1 min-w-[160px]"><Label>Alt text</Label><Input value={form.alt} onChange={(e) => setForm({ ...form, alt: e.target.value })} className="mt-1.5" /></div>
        <Button onClick={create} data-testid="media-add" className="rounded-full bg-emerald-600 hover:bg-emerald-700"><Plus className="mr-1.5 h-4 w-4" />Add</Button>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((m) => (
          <div key={m.id} className="group overflow-hidden rounded-xl border border-slate-200 bg-white">
            <div className="aspect-video bg-slate-100"><img src={m.url} alt={m.alt} className="h-full w-full object-cover" /></div>
            <div className="flex items-center justify-between p-2">
              <button onClick={() => { navigator.clipboard.writeText(m.url); toast.success("Copied"); }} className="flex items-center gap-1 text-xs text-slate-500 hover:text-emerald-700"><Copy className="h-3 w-3" />Copy</button>
              <button onClick={() => del(m.id)} className="text-red-500 hover:text-red-700"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full py-10 text-center text-slate-400">No media yet.</div>}
      </div>
    </div>
  );
}
